// ----------------------------------------------------------------------

export const mockImgCover = (index) => `/static/mock-images/covers/cover_${index}.jpg`;
export const mockImgProduct = (index) => `/static/mock-images/products/product_${index}.jpg`;
export const mockImgAvatar = (index) => `/static/mock-images/avatars/avatar_${index}.jpg`;
export const mockImgStory = (title) =>
  `/static/mock-images/stories/story_${title.toLowerCase().replaceAll(' ', '_')}.jpg`;
